<template lang="pug">
dialogs(:show.sync="show" :option="{ size: 'lg' }" :title="title" :className="pageType" :noCloseOnEsc="true")
  b-container(fluid)
    .context
      b-form
        .form-wrap
          b-form-group(
            content-cols-sm
            :label="$t('support_page.author')"
            label-for="creator"
            label-cols-sm="2"
            label-align-sm="left"
          )
            span {{ postForm.creator }}
            //- b-form-input#creator(v-model="postForm.creator" size="sm" style="width: 150px" disabled)
          
          b-form-group(
            content-cols-sm
            :label="$t('support_page.title')"
            label-for="title"
            label-cols-sm="2"
            label-align-sm="left"
          )
            b-form-input#title(v-model="postForm.title" size="sm" style="width: 100%")
          
          b-form-group(
            content-cols-sm
            :label="$t('support_page.content')"
            label-for="content"
            label-cols-sm="2"
            label-align-sm="left"
          )
            b-form-textarea#content(v-model="postForm.content" size="sm" style="width: 100%" :rows="10")

    .modal-footer
      b-button(size="sm" variant="primary" @click="submit" pill) {{ $t('enrollment') }}
      b-button(variant="secondary" size="sm" @click="$emit('close')" pill) {{$t('cancel')}}
</template>

<script>
import { user } from "@/api/access"
import { NoticeAPI } from "../../api"
import Dialogs from "@/components/mixins/dialog/index.vue"
import _ from "lodash"

const defaultForm = {
  language: "ko",
  creator: "",
  title: "",
  content: "",
}

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: null,
    },
    pk: {
      type: [String, Number],
      required: null,
    },
  },
  components: {
    Dialogs,
  },
  watch: {
    show(val) {
      if (val) {
        this.isEdit = false
        const getUser = user()
        this.postForm = _.cloneDeep(defaultForm)
        this.postForm.creator = getUser.name

        if (this.form) {
          this.isEdit = true
          this.postForm = _.cloneDeep(this.form)
        }
      }
    },
  },
  data() {
    return {
      title: this.$t('support_page.register_notice'),
      pageType: "type-layer",
      postForm: {},
      isEdit: false,
    }
  },
  methods: {
    submit() {
      if (!this.postForm.title) {
        this.AppState.$emit("show-message-dialog", { context: { path: "support_page.enter_title" } })
        return
      }
      if (!this.postForm.content) {
        this.AppState.$emit("show-message-dialog", { context: { path: "enter_content" } })
        return
      }
      if (!this.isEdit) {
        NoticeAPI.post("", this.postForm).then(resp => {
          this.$emit("complete")
        })
      } else {
        NoticeAPI.put(String(this.pk), this.postForm).then(resp => {
          this.$emit("complete")
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
